import { VerticalContainer } from '@american-autonomy/ag-ui';

import ComponentStatusRow from 'components/ComponentStatusRow';
import SkeletonText from 'components/loaders/SkeletonText';
import CaptionText from 'components/text/CaptionText';

import useData from './hooks/useData';

import { SECTION_SKELETON_LINES, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DroneComponentsTab: FunctionComponent<Props> = ({
    className = '',
    drone,
    testId = TEST_ID
}) => {
    const { isLoading, sections } = useData({ drone });

    const loadedSections = sections.map(section => (
        <VerticalContainer className={styles.section} key={section.titleKey}>
            <CaptionText className={styles.sectionTitle} text={section.title} />

            {section.rows.map(row => (
                <ComponentStatusRow
                    detail={row.detail}
                    key={row.label}
                    label={row.label}
                    percentRemaining={row.percentRemaining}
                    status={row.status}
                />
            ))}
        </VerticalContainer>
    ));

    const content = isLoading ? <SkeletonText lines={SECTION_SKELETON_LINES} /> : loadedSections;

    return (
        <VerticalContainer className={`${className} ${styles.droneComponentsTab}`} testId={testId}>
            {content}
        </VerticalContainer>
    );
};

export default DroneComponentsTab;
